import { Routes } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { LoginComponent } from "./login/login.component";
import { HomeRedirectComponent } from './home/home-redirect.component';
import { AuthGuard } from './_guards/auth.guard';
import { RoleGuard } from './_guards/role.guard';
import { LEADS_BID_GROUP_CALCULATOR_ROLES } from './_constants/role-permissions';
import { LEGACY_CHECK_REDIRECTS } from './checks/legacy-check-redirects';

export const Approutes: Routes = [
  {
    path: '',
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: HomeRedirectComponent,
      },
      {
        path: 'profile',
        loadChildren: () => import('./profile/profile.module').then((m) => m.ProfileModule),
      },
      // Old check-page URLs, ahead of 'projects' so they win over 'projects/:id' (SPAR-973).
      ...LEGACY_CHECK_REDIRECTS,
      {
        path: 'projects',
        loadChildren: () => import('./projects/projects.module').then((m) => m.ProjectsModule),
      },
      {
        path: 'allocations',
        loadChildren: () => import('./allocations/allocations.module').then((m) => m.AllocationsModule),
      },
      {
        path: 'leads',
        loadChildren: () => import('./leads/leads.module').then((m) => m.LeadsModule),
      },
      {
        path: 'invoices',
        loadChildren: () => import('./invoices/invoices.module').then((m) => m.InvoicesModule),
      },
      {
        // Its own top-level section rather than a Leads child (SPAR-808). The component is
        // standalone, so it loads directly without a feature module of its own.
        path: 'split-calculator',
        loadComponent: () =>
          import('./leads/bid-group-calculator/bid-group-calculator.component').then(
            (m) => m.BidGroupCalculatorComponent
          ),
        canActivate: [RoleGuard],
        data: {
          title: 'Split Calculator',
          allowedRoles: LEADS_BID_GROUP_CALCULATOR_ROLES
        },
      },
      {
        path: 'checks',
        loadChildren: () => import('./checks/checks.module').then((m) => m.ChecksModule),
      },
      {
        path: 'dashboards',
        loadChildren: () => import('./dashboards/dashboards.module').then((m) => m.DashboardsModule),
      },
      {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
      },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login'
    }
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () => import('./authentication/authentication.module').then((m) => m.AuthenticationModule),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/authentication/404',
  },
];
